module.exports = __webpack_public_path__ + "static/media/few-clouds-day.80a5d865.svg";